'use client';
import { Box } from '@mui/material';
import { useRouter } from 'next/navigation';
import { ErrorState } from '../../components/emptyState';

/**
 * ErrorPage renders the error state of a section with a retry action, as in customer-mobile.
 *
 * @param {Function} [onRetry] - Optional retry handler, defaults to refreshing the route.
 * @param {string} [title] - What failed, e.g. "No pudimos cargar tus operaciones".
 * @param {string} [body] - Optional hint below the title.
 * @returns {React.JSX.Element} The rendered ErrorPage component.
 */
export const ErrorPage = ({
  onRetry,
  title = '¡Ups! Algo salió mal',
  body = 'Tuvimos un problema de nuestro lado. Intentá de nuevo en unos minutos.',
}: { onRetry?: () => void; title?: string; body?: string } = {}) => {
  const router = useRouter();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }} data-testid="error-page">
      <ErrorState title={title} body={body} onRetry={onRetry ?? (() => router.refresh())} />
    </Box>
  );
};
